export const VALIDATION_TYPE = {
  SIMPLE: 0,
  REGEX: 1,
};
